import type { OrgTreeNode } from '../model/organizationSchema';

/**
 * GET /api/organization/tree
 *
 * Бэкенд: id, label, depth, children (id дочерних), department (опционально).
 * Поле icon НЕ приходит с бэка — подставляется на фронте по type/depth.
 */
export const orgTree: OrgTreeNode[] = [
  { id: 'smz', label: 'АО «СМЗ»', depth: 0, children: ['prod', 'svc'] },
  { id: 'prod', label: 'Производство', depth: 1, children: ['c1', 'c2', 'c3', 'c4'] },
  { id: 'c1', label: 'Цех №1 (Литейный)', depth: 2, children: [], department: 'Цех №1' },
  { id: 'c2', label: 'Цех №2 (Механосборочный)', depth: 2, children: [], department: 'Цех №2' },
  { id: 'c3', label: 'Цех №3 (Ремонтный)', depth: 2, children: [], department: 'Цех №3' },
  { id: 'c4', label: 'Цех №4 (Энергетический)', depth: 2, children: [], department: 'Цех №4' },
  { id: 'svc', label: 'Вспомогательные службы', depth: 1, children: ['otk', 'ogt', 'aho', 'buh'] },
  { id: 'otk', label: 'ОТК', depth: 2, children: [], department: 'ОТК' },
  { id: 'ogt', label: 'ОГТ', depth: 2, children: [], department: 'ОГТ' },
  { id: 'aho', label: 'АХО', depth: 2, children: [], department: 'АХО' },
  { id: 'buh', label: 'Бухгалтерия', depth: 2, children: [], department: 'Бухгалтерия' },
];
